import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import React from "react";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { CRMStatusPill } from "../../../../components/CRMStatusPill";
import { ManageAccountsDrawerScreenToParametersMap } from "../../../../types";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export const EmailForwardingSetupSection: React.FC = () => {
  const { t } = useTranslations();
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();

  return (
    <CRMInfoSection
      title={
        <div className="flex items-center gap-2.5">
          <span>
            {t({
              id: "client-support-page.set-email-forwarding",
              defaultMessage: "Set Email Forwarding",
            })}
          </span>
          <CRMStatusPill status="required" size="sm" />
        </div>
      }
      items={[
        {
          tips: [
            t({
              id: "client-support-page.email-forwarding-forward-to-inbox",
              defaultMessage:
                "Forward your emails to your Jugl Inbox so that AI Agent or your team can handle it in one place",
            }),
            t({
              id: "client-support-page.email-forwarding-support-any-provider",
              defaultMessage:
                "Support any provider (Gmail, Outlook, Zoho, custom domain, etc.)",
            }),
            t({
              id: "client-support-page.email-forwarding-domain-verification",
              defaultMessage: "Domain verification available (optional)",
            }),
          ],
        },
      ]}
      rightContent={
        <Button
          variant="primary"
          iconEnd={<ArrowRightIcon />}
          onClick={() =>
            transitionTo({ name: "emailSetup", step: "enterEmail" })
          }
        >
          {t({
            id: "client-support-page.setup",
            defaultMessage: "Setup",
          })}
        </Button>
      }
    />
  );
};
